import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const COLORS = ['#0a72e7', '#f59e0b', '#10b981', '#ef4444'];

function CallVolumeChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100%', color: 'var(--text-muted)', fontSize: '14px'
      }}>No call volume data available</div>
    );
  }

  const formatted = data.map((item, i) => ({
    ...item,
    fill: COLORS[i % COLORS.length]
  }));

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={formatted} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
        <XAxis dataKey="label" tick={{ fontSize: 12, fill: '#6b7280' }} axisLine={{ stroke: '#e5e7eb' }} />
        <YAxis tick={{ fontSize: 12, fill: '#6b7280' }} axisLine={{ stroke: '#e5e7eb' }} allowDecimals={false} />
        <Tooltip contentStyle={{
          background: 'white', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-sm)', boxShadow: 'var(--shadow-md)', fontSize: '13px'
        }} formatter={(value) => [`${value} calls`, 'Volume']} />
        <Bar dataKey="value" radius={[4, 4, 0, 0]}>
          {formatted.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.fill} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default CallVolumeChart;
